import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';

export default function CalendarUI({onChange}){
    return <div className="m-1 d-flex align-item-center justify-content-center">
     <Calendar style={{ width: 'inherit',
    border: 'none !important'}} minDate={new Date()} onChange={onChange} onClick={(value) => console.log('New date fsdfis: ', value)}/>
     </div>
}